export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth',
  },
]

export const _ = undefined



// WEBPACK FOOTER //
// ./src/libs/acl/config.js